import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useProductDetailSlots, isSinglePurchase, isSubscriptionPurchase } from '@grandvisionhq/fun-products';
import { useFeatureToggles } from '@grandvisionhq/state';
import { useCLEcommContext } from './context/CLEcommContext.js';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';
import { ProductLabelTag } from '../../Components/ProductLabelTag/ProductLabelTag.js';
import { CLPriceSection } from './components/CLPriceSection/CLPriceSection.js';
import { LensesPerBox } from './components/LensesPerBox/LensesPerBox.js';
import { LensesStarReview } from '../components/LensesStarReview/LensesStarReview.js';
import { CLPurchaseTypeSelectionBoxes } from './components/CLPurchaseTypeSelectionBoxes/CLPurchaseTypeSelectionBoxes.js';
import { ContactLensesSinglePurchase } from './components/ContactLensesSinglePurchase/ContactLensesSinglePurchase.js';
import { ContactLensesSubscriptionPurchase } from './components/ContactLensesSubscriptionPurchase/ContactLensesSubscriptionPurchase.js';
import { ContactLensesRxInfoModal } from './components/ContactLensesRxInfoModal/ContactLensesRxInfoModal.js';
import { CLDeliveryIndicator } from './components/CLDeliveryIndicator/CLDeliveryIndicator.js';
import { ContactLensesCTA } from './components/ContactLensesCTA/ContactLensesCTA.js';

const ContactLensesEcommContent = ({ ctaRef  })=>{
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { isContactLensEnabled  } = useFeatureToggles();
    const { activeVariant  } = useProductDetailContext();
    const { Slots  } = useProductDetailSlots();
    const { state  } = useCLEcommContext();
    const { purchaseType  } = state.configurations;
    const onlinePurchasingAllowed = isContactLensEnabled && !activeVariant.excludedFromCheckout;
    return /*#__PURE__*/ React.createElement("section", {
        className: "contact-lenses-ecomm-content"
    }, /*#__PURE__*/ React.createElement(ProductLabelTag, {
        className: "contact-lenses-ecomm-content__tag"
    }), /*#__PURE__*/ React.createElement(CLPriceSection, {
        className: "contact-lenses-ecomm-content__price"
    }), Slots.AfterPrice && /*#__PURE__*/ React.createElement(Slots.AfterPrice, null), /*#__PURE__*/ React.createElement(LensesPerBox, {
        className: "contact-lenses-ecomm-content__package-quantity"
    }), !isMobile && /*#__PURE__*/ React.createElement(LensesStarReview, {
        className: "contact-lenses-ecomm-content__star-review"
    }), onlinePurchasingAllowed && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CLPurchaseTypeSelectionBoxes, {
        className: "contact-lenses-ecomm-content__purchase-type"
    }), isSinglePurchase(purchaseType) && /*#__PURE__*/ React.createElement(ContactLensesSinglePurchase, null), isSubscriptionPurchase(purchaseType) && /*#__PURE__*/ React.createElement(ContactLensesSubscriptionPurchase, null), /*#__PURE__*/ React.createElement(ContactLensesRxInfoModal, {
        className: "contact-lenses-ecomm-content__info-modal"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "contact-lenses-ecomm-content__cta-section"
    }, /*#__PURE__*/ React.createElement(CLDeliveryIndicator, null), /*#__PURE__*/ React.createElement("div", {
        ref: ctaRef
    }, /*#__PURE__*/ React.createElement(ContactLensesCTA, {
        className: "contact-lenses-ecomm-content__cta"
    })), Slots.AfterCTA && /*#__PURE__*/ React.createElement(Slots.AfterCTA, null)));
};

export { ContactLensesEcommContent };
//# sourceMappingURL=ContactLensesEcommContent.js.map
